
import React from 'react';
import { Card } from '@/components/ui/card';
import { BookOpen, Clock } from 'lucide-react';
import { Teacher } from '@/types/teacher.types';
import { to12HourFormat } from '@/utils/formatters';

interface TeacherScheduleTabProps {
  teacher: Teacher;
}

export const TeacherScheduleTab = ({ teacher }: TeacherScheduleTabProps) => {
  return (
    <>
      <h3 className="text-xl font-semibold mb-4">Teaching Schedule</h3>
      {teacher.departments && teacher.departments.length > 0 ? (
        <div className="space-y-4">
          {teacher.departments.map((dept: any, index: number) => (
            <Card key={index} className="p-4 border">
              <div className="flex flex-col space-y-2">
                <div className="flex justify-between items-center">
                  <h4 className="font-medium text-lg">{dept.name || 'Department'}</h4>
                  <span className="text-sm bg-primary/10 text-primary px-2 py-1 rounded">
                    {dept.classType || 'Class type not specified'}
                  </span>
                </div>
                <p className="text-gray-700"><BookOpen className="inline w-4 h-4 mr-1" /> {dept.subject || 'Subject not specified'}</p>
                <div className="flex items-center text-gray-600">
                  <Clock className="w-4 h-4 mr-2" />
                  <span>
                    {dept.startTime && dept.endTime 
                      ? `${to12HourFormat(dept.startTime)} - ${to12HourFormat(dept.endTime)}` 
                      : 'Time not specified'}
                  </span>
                </div>
                <div className="flex flex-wrap gap-1 mt-2">
                  {dept.days && dept.days.length > 0 ? (
                    dept.days.map((day: string, dayIndex: number) => (
                      <span key={dayIndex} className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs">
                        {day}
                      </span>
                    ))
                  ) : (
                    <span className="text-gray-500">No days specified</span>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No teaching schedule available</p>
      )}
    </>
  );
};
